import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Snackbar, Alert } from "@mui/material";
import { hideToast } from "../../store/slices/toastSlice";

const ToastManager = () => {
  const { open, message, severity } = useSelector((state) => state.toast);
  const dispatch = useDispatch();

  const handleClose = () => dispatch(hideToast());

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert onClose={handleClose} severity={severity} variant="filled">
        {message}
      </Alert>
    </Snackbar>
  );
};

export default ToastManager;
